const adminUrl = '/admin';

export default adminUrl;
